"use strict";

CODE.pageScript = CODE.pageScript || {
  init: {}
};
CODE.pageScript = function () {
  /* ============================
   * 初期化
   * ============================ */
  function init() {
    initFvSlider();
    initQuantity();
    initPhilosophy();
    initHeaderLogo();
  }

  /* ============================
   * メインビジュアル スライダー
   * フェード切り替え
   * ============================ */
  function initFvSlider() {
    var el = document.querySelector('.js-fvSlider');
    if (!el) return;
    var fv = document.querySelector('.js-fv');
    if (fv) fv.dataset.fv = Math.floor(Math.random() * 7) + 1;
    new Swiper(el, {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      pagination: {
        el: '.fvSlider_pagination',
        clickable: true
      }
    });
  }

  /* ============================
   * 数量増減ボタン
   * ============================ */
  function initQuantity() {
    $(document).on('click', '.js-quantityMinus', function () {
      var $input = $(this).siblings('.js-quantityInput');
      var val = parseInt($input.val(), 10);
      if (val > 1) $input.val(val - 1);
    });
    $(document).on('click', '.js-quantityPlus', function () {
      var $input = $(this).siblings('.js-quantityInput');
      $input.val(parseInt($input.val(), 10) + 1);
    });
  }

  /* ============================
   * Philosophy セクション
   * スクロール量に応じて背景画像切り替え・縮小・テキスト表示
   *
   * 構造:
   *   .philosophyCover (sticky, overflow:hidden, 100vh)
   *     ├ .philosophyCover_inner (画面中央の0×0基準点)
   *     │   ├ .philosophyCode (absolute)
   *     │   └ .philosophyCatch (absolute)
   *     └ .philosophyBg (absolute, 中央配置, width/heightで縮小)
   *         └ .philosophyBg_inner → .philosophyBg_item × 8
   *   .philosophyContent (relative, スクロール量を生むための高さ)
   *
   * 前半(45%): 画像1~4フェードアウト → is-switched付与
   * 後半(55%): bg縮小(scrub) + 画像5~7フェードアウト → 完了時にcode/catch表示
   * ============================ */
  function initPhilosophy() {
    var content = document.querySelector('.js-philosophyContent');
    if (!content || typeof gsap === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    // 調整定数
    var FRONT = 4; // 前半で消す画像枚数
    var RATIO = 0.45; // 前半が占めるスクロール割合
    var MARGIN = 0.15; // 縮小endを手前にずらす割合（scrub補間余裕）
    var SCRUB = 0.5; // 縮小scrub補間（秒）
    var FADE = 0.6; // 画像フェードduration（秒）
    var PC = 560 / 1280; // PC縮小比率
    var SP = {
      w: 276,
      h: 192,
      base: 375
    }; // SP縮小比率
    var BOTTOM = 290; // 縮小画像下辺からの最小余白（px）

    // DOM
    var items = document.querySelectorAll('.js-philosophyBgItem');
    var bg = document.querySelector('.js-philosophyBg');
    var section = document.querySelector('.js-philosophy');
    var leads = content.querySelectorAll('.js-philosophyLead');
    var code = document.querySelector('.js-philosophyCode');
    var catchEl = document.querySelector('.js-philosophyCatch');
    var triggers = [];

    // ヘルパー
    function at(px) {
      return 'top+=' + Math.floor(px) + ' top';
    }
    function addTrigger(opts) {
      triggers.push(ScrollTrigger.create(Object.assign({
        trigger: content
      }, opts)));
    }
    function onClassToggle(els, cls, start, triggerEl) {
      addTrigger({
        trigger: triggerEl || content,
        start: start,
        onEnter: function onEnter() {
          els.forEach(function (n) {
            n.classList.add(cls);
          });
        },
        onLeaveBack: function onLeaveBack() {
          els.forEach(function (n) {
            n.classList.remove(cls);
          });
        }
      });
    }
    function onFadeOut(idx, px) {
      addTrigger({
        start: at(px),
        onEnter: function onEnter() {
          gsap.to(items[idx], {
            opacity: 0,
            duration: FADE
          });
        },
        onLeaveBack: function onLeaveBack() {
          gsap.to(items[idx], {
            opacity: 1,
            duration: FADE
          });
        }
      });
    }
    function build() {
      // リセット
      triggers.forEach(function (t) {
        t.kill();
      });
      triggers = [];
      gsap.set([bg, items], {
        clearProps: 'all'
      });
      [section, code, catchEl].forEach(function (n) {
        if (n) n.className = n.className.replace(/\bis-\S+/g, '');
      });
      section.style.paddingBottom = '';
      leads.forEach(function (n) {
        n.classList.remove('is-inview');
      });

      // レイアウト計算
      var w = window.innerWidth,
        h = window.innerHeight;
      var portrait = w < h;
      var dist = content.offsetHeight - h;
      var sw = dist * RATIO; // 前半終了点
      var end = dist - content.offsetHeight * MARGIN; // 後半終了点
      var span = end - sw; // 後半の距離
      var remain = items.length - FRONT;
      var tw = portrait ? SP.w / SP.base * w : PC * w;
      var th = portrait ? tw * SP.h / SP.w : PC * h;

      // 前半: 画像1~4フェードアウト
      for (var i = 0; i < FRONT; i++) onFadeOut(i, sw / FRONT * i);

      // 前半完了: is-switched
      onClassToggle([section], 'is-switched', at(sw));

      // 縮小アニメーション
      triggers.push(gsap.to(bg, {
        width: tw,
        height: th,
        ease: 'none',
        force3D: true,
        scrollTrigger: {
          trigger: content,
          start: at(sw),
          end: 'bottom-=' + MARGIN * 100 + '% bottom',
          scrub: SCRUB
        }
      }).scrollTrigger);

      // 後半: 画像5~7フェードアウト（8枚目は残す）
      for (var i = 0; i < remain - 1; i++) onFadeOut(FRONT + i, sw + span / remain * (i + 1));

      // 縮小完了: code/catch表示
      onClassToggle([code, catchEl].filter(Boolean), 'is-visible', at(end));

      // リード文
      leads.forEach(function (el) {
        onClassToggle([el], 'is-inview', 'top 60%', el);
      });

      // 縮小画像下の余白確保
      var gap = BOTTOM - (h - th) / 2;
      if (gap > 0) section.style.paddingBottom = gap + 'px';
    }
    build();
    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(build, 200);
    });
  }

  /* ============================
   * ヘッダーロゴ表示
   * fvCoverが画面外に出たら表示
   * ============================ */
  function initHeaderLogo() {
    var fvCover = document.querySelector('.js-fvCover');
    var headerLogo = document.querySelector('.js-headerLogo');
    if (!fvCover || !headerLogo || typeof gsap === 'undefined') return;
    ScrollTrigger.create({
      trigger: fvCover,
      start: 'bottom top',
      onEnter: function onEnter() {
        headerLogo.classList.add('is-visible');
      },
      onLeaveBack: function onLeaveBack() {
        headerLogo.classList.remove('is-visible');
      }
    });
  }
  return {
    init: init
  };
}();
CODE.common.init(CODE.pageScript.init);